(() => {
  const header = document.querySelector('[data-wk-site-header]');
  if (!header || header.dataset.ready) return;
  header.dataset.ready = 'true';
  const menus = [...header.querySelectorAll('.wk-site-menu')];
  const wrap = header.querySelector('.wk-site-search-wrap');
  const input = wrap.querySelector('input[name=q]');
  const box = wrap.querySelector('[data-wk-search-guides]');
  const productResults = box.querySelector('[data-search-products]');
  const careResults = box.querySelector('[data-search-care]');
  const status = box.querySelector('[data-search-status]');
  const allResults = box.querySelector('[data-search-all]');
  const navLinks = [...header.querySelectorAll('.wk-site-nav a')].filter(link => new URL(link.href).pathname.includes('/pages/'));
  let timer, controller, revision = 0;

  function closeSearch() {
    clearTimeout(timer);
    controller?.abort();
    revision++;
    box.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  }
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (menu.open) {
      closeSearch();
      menus.forEach(other => { if (other !== menu) other.open = false; });
    }
  }));
  document.addEventListener('click', event => {
    if (!header.contains(event.target)) menus.forEach(menu => { menu.open = false; });
    if (!wrap.contains(event.target)) closeSearch();
  });
  header.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (!box.hidden) { input.focus(); closeSearch(); return; }
    const opened = menus.find(menu => menu.open);
    if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
  });
  box.querySelector('[data-search-close]').addEventListener('click', () => {
    input.focus();
    closeSearch();
  });
  wrap.addEventListener('focusout', () => {
    setTimeout(() => { if (!wrap.contains(document.activeElement)) closeSearch(); }, 0);
  });
  function resizeHeader() {
    const height = header.offsetHeight + 'px';
    document.documentElement.style.setProperty('--wk-header-height', height);
    document.body.style.setProperty('--header-height', height);
    document.body.style.setProperty('--header-group-height', height);
  }
  if (window.ResizeObserver) new ResizeObserver(resizeHeader).observe(header);
  else window.addEventListener('resize', resizeHeader);
  resizeHeader();

  let cartRevision = 0;
  function setCartCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    header.querySelectorAll('[data-wk-cart-count]').forEach(node => { node.replaceChildren(Object.assign(document.createElement('span'),{className:'visually-hidden',textContent:'Items in basket: '}),document.createTextNode(String(count))); });
  }
  async function refreshCart() {
    const current = ++cartRevision;
    try {
      const response = await fetch(header.dataset.cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (response.ok) { const cart = await response.json(); if (current === cartRevision) setCartCount(cart.item_count); }
    } catch {}
  }
  document.addEventListener('wk:cart-updated', event => { cartRevision++; setCartCount(event.detail?.item_count); });
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, event => {
      const current = ++cartRevision;
      event.promise?.then(({ cart }) => {
        if (current !== cartRevision) return;
        if (Number.isInteger(cart?.totalQuantity)) setCartCount(cart.totalQuantity);
        else refreshCart();
      }).catch(() => {});
    });
  }).catch(() => {});
  window.addEventListener('pageshow', refreshCart);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCart(); });

  function guideMatches(query) {
    const synonym={postage:'delivery',shipping:'delivery',refund:'guarantee',returns:'guarantee',address:'visit',hours:'visit',opening:'visit',sick:'urgent',ill:'urgent'}; const words = query.toLowerCase().trim().split(/\s+/).filter(Boolean).map(w=>synonym[w]||w);
    const seen = new Set();
    return navLinks.filter(link => {
      const terms=(link.textContent+' '+(link.dataset.guideTerms||'')).toLowerCase();
      if (seen.has(link.href) || !words.every(word => terms.includes(word))) return false;
      seen.add(link.href);
      return true;
    }).slice(0, 6);
  }
  function appendLinks(target, links) {
    for (const original of links) {
      const link = document.createElement('a');
      link.href = original.href;
      link.textContent = original.textContent;
      target.append(link);
    }
  }
  function renderCare(query) {
    careResults.replaceChildren();
    const matches = guideMatches(query);
    if (!matches.length) return;
    const title = document.createElement('strong');
    title.textContent = careResults.getAttribute('aria-label');
    careResults.append(title);
    appendLinks(careResults, matches);
  }
  async function findProducts(query, current) {
    if (!wrap.dataset.predictiveUrl) { status.textContent = ''; return; }
    const request = new AbortController();
    controller = request;
    const timeout = setTimeout(() => request.abort(), 6000);
    try {
      const url = new URL(wrap.dataset.predictiveUrl, location.origin);
      url.searchParams.set('q', query.replace(/pearl\s+scale/ig,'pearlscale'));
      url.searchParams.set('section_id', 'wk-search-results');
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');
      const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Search unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (current !== revision || box.hidden) return;
      const results = doc.querySelector('[data-wk-product-results]');
      if (!results) throw new Error('Search unavailable');
      productResults.replaceChildren(results);
      status.textContent = results.querySelector('a') ? '' : 'No available product matched. Try a shorter name, browse fish, or see the help links below.';
    } catch {
      if (current === revision && !box.hidden) status.textContent = status.dataset.unavailable;
    } finally { clearTimeout(timeout); }
  }
  function suggest() {
    clearTimeout(timer);
    controller?.abort();
    const current = ++revision;
    const query = input.value.trim();
    if (query.length < 2) { closeSearch(); return; }
    menus.forEach(menu => { menu.open = false; });
    productResults.replaceChildren();
    renderCare(query);
    const url = new URL(wrap.querySelector('form').action);
    url.searchParams.set('q', query);
    url.searchParams.set('options[prefix]', 'last');
    allResults.href = url.href;
    box.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    status.textContent = status.dataset.loading;
    timer = setTimeout(() => findProducts(query, current), 220);
  }
  input.addEventListener('input', suggest);
  input.addEventListener('focus', suggest);
  wrap.querySelector('form').addEventListener('submit', closeSearch);
  wrap.addEventListener('keydown', event => {
    if (box.hidden || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    const links = [...box.querySelectorAll('a[href]')];
    if (!links.length) return;
    event.preventDefault();
    const current = links.indexOf(document.activeElement);
    const next = event.key === 'ArrowDown' ? current + 1 : current - 1;
    if (next < 0) input.focus();
    else links[Math.min(next, links.length - 1)].focus();
  });
  if (/\/search\/?$/.test(location.pathname) && input.value.trim().length > 1) {
    const matches = guideMatches(input.value);
    const main = document.getElementById('MainContent');
    if (matches.length && main) {
      const section = document.createElement('section');
      section.className = 'wk-search-help';
      const title = document.createElement('h2');
      title.textContent = careResults.getAttribute('aria-label');
      section.append(title);
      appendLinks(section, matches);
      main.prepend(section);
    }
  }
})();

document.addEventListener('click', event => {
  const link = event.target.closest?.('[data-wk-cookie]');
  if (link && window.privacyBanner?.showPreferences) {
    event.preventDefault();
    Promise.resolve(window.privacyBanner.showPreferences()).catch(() => location.assign(link.href));
  }
});

